import * as React from "react";
import { Tooltip } from "@material-ui/core";

import {
  createTheme,
  MuiThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
const defaultTheme = createTheme();
const theme = createTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "2em",
        color: "yellow",
        backgroundColor: "red",
      },
    },
  },
});
const WhiteOnBlackTooltip = withStyles({
  arrow: {
    "&:before": {
      border: "1px solid #E6E8ED",
    },
    color: "white",
  },
  tooltip: {
    // color: "black",
    backgroundColor: "white",
    fontFamily: "Roboto-Bold",
    color: "#212121",
    fontSize: "12px",
    lineHeight: "14px",
    boxShadow: "0px 3px 6px #00000029",
  },
})(Tooltip);
export default function ArrowTooltips(props) {
  return (
    <MuiThemeProvider theme={theme}>
      <WhiteOnBlackTooltip
        title={`${props?.title}`}
        placement="top"
        open={props?.open}
        // style={{ width: `${props?.now}%` }}
        arrow
      >
        {props?.display}
      </WhiteOnBlackTooltip>
    </MuiThemeProvider>
  );
}
